import * as Yup from 'yup';

export const emptyStringToNull = (value, originalValue) =>
  originalValue === '' ? null : value;

export const valuationsSchema = Yup.array().of(
  Yup.object().shape({
    amount: Yup.number(),
    date: Yup.date()
  })
);

export const statusHistorySchema = Yup.array()
  .nullable()
  .of(
    Yup.object().shape({
      status: Yup.string().required(),
      date: Yup.date(),
      current: Yup.bool(),
      active: Yup.bool()
    })
  );

export const operationCostsSchema = Yup.array()
  .nullable()
  .of(
    Yup.object().shape({
      productId: Yup.string().default(''),
      operationCost: Yup.string()
        .nullable()
        .default(null)
        .defined()
    })
  );

export const historySchema = Yup.array()
  .nullable()
  .of(
    Yup.object().shape({
      purchasePrice: Yup.number().nullable(),
      purchaseDate: Yup.date().nullable(),
      currentValue: Yup.number().nullable(),
      currentValueDate: Yup.date().nullable()
    })
  );

export default Yup.object().shape({
  currentStatus: Yup.string().required('Current Status is a required field'),
  currentStatusDate: Yup.date()
    .nullable()
    .transform(emptyStringToNull),
  equipmentType: Yup.string().required('Type is a required field'),
  licenseNumber: Yup.string().default(''),
  make: Yup.string().default(''),
  manufacturedYear: Yup.number()
    .nullable()
    .transform(emptyStringToNull)
    .integer('Manufactured year must be a whole number')
    .min(1000, 'Manufactured year must be a 4-digit year')
    .max(9999, 'Manufactured year must be a 4-digit year')
    .default(null)
    .defined(),
  model: Yup.string().default(''),
  modelYear: Yup.number()
    .nullable()
    .transform(emptyStringToNull)
    .integer('Model year must be a whole number')
    .min(1000, 'Model year must be a 4-digit year')
    .max(9999, 'Model year must be a 4-digit year')
    .default(null)
    .defined(),
  name: Yup.string()
    .trim()
    .required('Name is a required field'),
  purchasePrice: Yup.string()
    .nullable()
    .default(null)
    .defined(),
  purchasePriceDate: Yup.date()
    .nullable()
    .transform(emptyStringToNull)
    .default(null)
    .defined(),
  currentValue: Yup.string()
    .nullable()
    .default(null)
    .defined(),
  currentValueDate: Yup.date()
    .nullable()
    .transform(emptyStringToNull)
    .default(null)
    .defined(),
  notes: Yup.string().default(''),
  serialNumber: Yup.string().default(''),
  unitID: Yup.string().default(''),
  statusHistory: statusHistorySchema,
  services: operationCostsSchema,
  history: historySchema
});
